export const makeImagesResponsive = (html: string) => {
  const container = document.createElement('div')
  container.innerHTML = html

  container.querySelectorAll('img').forEach((image) => {
    image.removeAttribute('width')
    image.removeAttribute('height')
    image.style.width = '100%'
    image.style.maxWidth = '100%'
    image.style.height = 'auto'
  })

  return container.innerHTML
}
